export default __webpack_public_path__ + "static/media/img-stake-new-exchanges.26407894.png";